import React, { useState, useEffect, useRef } from 'react';

// --- داده‌های اعضا ---
const otherMembers = [
    {
        id: 2,
        name: "کیارش ارکانی",
        role: "طراح وب سایت",
        image: "https://daneshesaze.com/members/person2.jpg",
        bio: `
            <ul class="list-none space-y-2 text-sm text-slate-700">
               <li>دانشجوی دکتری مهندسی زلزله</li>
               <li>دانشگاه صنعتی نوشیروانی بابل</li>
                <li>مدیر گروه ارکانی عمران</li>
                <li>مدرس دانشگاه</li>
                <li>طراح و محاسب سازه ها</li>
            </ul>
            <div class="flex justify-center gap-4 mt-4">
                <a href="https://arkaniomran.ir/" target="_blank" class="text-blue-600 hover:text-blue-800 font-bold">وبسایت شخصی</a>
                <a href="https://t.me/arkaniomran" target="_blank" class="text-blue-500 hover:text-blue-700">
                    تلگرام
                </a>
            </div>
        `
    },
    {
        id: 3,
        name: "سارا فرزانه",
        role: "ادمین یوتیوب و اینستاگرام",
        image: "https://daneshesaze.com/members/person3.jpg",
        bio: `
            <ul class="list-none space-y-2 text-sm text-slate-700">
                <li>دانشجوی دکتری مهندسی زلزله</li>
                <li>دانشگاه صنعتی نوشیروانی بابل</li>
                <li>طراح و محاسب سازه ها</li>
            </ul>
            <div class="mt-4 text-sm text-blue-600 font-bold">ایمیل: sar.farzaneh@gmail.com</div>
        `
    },
    {
        id: 4,
        name: "حامد قدیمی مقدم",
        role: "ادمین تلگرام",
        image: "https://daneshesaze.com/members/person4.jpg",
        bio: `
            <ul class="list-none space-y-2 text-sm text-slate-700">
                <li>دانشجوی دکتری مهندسی سازه</li>
                <li>دانشگاه آزاد اسلامی مشهد</li>
                <li>طراح و محاسب سازه ها</li>
            </ul>
            <div class="mt-4 text-sm text-blue-600 font-bold">ایمیل: hamedghadimi76@gmail.com</div>
        `
    }
];

export default function AboutUs() {
    // Animation Refs & State
    const drSectionRef = useRef(null);
    const membersGridRef = useRef(null);
    const [drSectionVisible, setDrSectionVisible] = useState(false);
    const [membersVisible, setMembersVisible] = useState(false);

    // Intersection Observer for Animations
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (entry.target === drSectionRef.current) setDrSectionVisible(true);
                    if (entry.target === membersGridRef.current) setMembersVisible(true);
                }
            });
        }, { threshold: 0.2 });

        if (drSectionRef.current) observer.observe(drSectionRef.current);
        if (membersGridRef.current) observer.observe(membersGridRef.current);

        return () => observer.disconnect();
    }, []);

    return (
        <div className="container mx-auto px-4 py-12 animate-fadeIn">
            {/* Dr. Khosravi Section */}
            <div ref={drSectionRef} className="mb-24 flex justify-center">
                <div 
                    className={`dr-inner-card flex flex-col md:flex-row-reverse items-center gap-8 p-8 rounded-[53px] bg-[#f0f0f3] shadow-neu transition-all duration-1000 ${drSectionVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-20'}`}
                    style={{ minHeight: '500px' }}
                >
                    <div className="text-right rtl min-w-[300px] flex-grow">
                        <div className={`transition-all duration-1000 delay-300 ${drSectionVisible ? 'opacity-100' : 'opacity-0'}`}>
                            <h2 className="text-3xl font-bold text-slate-800 mb-2">دکتر حر خسروی</h2>
                            <span className="text-lg text-blue-600 font-medium block mb-4">مدیر سایت دانش سازه</span>
                            <span className="text-lg text-blue-600 font-medium block mb-4">عضو هیئت علمی دانشگاه صنعتی نوشیروانی بابل</span>
                            <span className="text-lg text-blue-600 font-medium block mb-4">دکتری مهندسی سازه و زلزله از دانشگاه صنعتی شریف</span>
                            <span className="text-lg text-black-400 font-medium block mb-4">حوزه‌های تخصصی:</span>
                            <ul className="text-lg text-black-600 font-medium space-y-2 mr-4">
                                <li>تحلیل سازه ها</li>
                                <li>طراحی سازه های فولادی</li>
                                <li>طراحی سازه های بتنی</li>
                                <li>نرم افزارهای مهندسی سازه</li>
                            </ul>
                        </div>
                    </div>
                    <div className="relative flex-shrink-0">
                         <img 
                            src="https://daneshesaze.com/members/person1.jpg"
                            alt="Dr Khosravi"
                            className={`w-[300px] h-[500px] object-cover rounded-[40px] transition-all duration-1000 ${drSectionVisible ? 'grayscale-0' : 'grayscale'}`}
                            onError={(e) => {
                                e.target.src = 'https://placehold.co/300x500/gray/white?text=Dr+Khosravi';
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Other Members */}
            <div className="max-w-6xl mx-auto">
                <div ref={membersGridRef} className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {otherMembers.map((member, idx) => (
                        <div 
                            key={member.id}
                            className={`member-card rounded-[30px] overflow-hidden bg-[#f0f0f3] shadow-neu flex flex-col transition-all duration-700 ${membersVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                            style={{ transitionDelay: `${idx * 200}ms` }}
                        >
                            <div className="relative overflow-hidden rounded-t-[30px]">
                                <img 
                                    src={member.image} 
                                    alt={member.name} 
                                    className={`w-full h-80 object-cover transition-all duration-1000 ${membersVisible ? 'grayscale-0' : 'grayscale'}`}
                                    onError={(e) => e.target.src='https://placehold.co/400x500/gray/white?text=Member'}
                                />
                            </div>
                            <div className="p-6 text-center">
                                <h3 className="text-lg font-bold text-slate-800 mb-1">{member.name}</h3>
                                <span className="text-sm text-blue-600 font-medium block mb-2">{member.role}</span>
                                <div className={`overflow-hidden transition-all duration-1000 ${membersVisible ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
                                    <hr className="border-slate-300 my-2 w-1/2 mx-auto" />
                                    <div className="text-right rtl text-sm" dangerouslySetInnerHTML={{ __html: member.bio }} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}